{
  "name": "@ns/public-ledger-auto-payments-change-target",
  "version": "1.2.0",
  "description": "The automatic payments £ target buys less than it did (#25 phase 4): REASON BELOW_PERCENT (under the signatories' price alert, charges go on) or STOPPED (no more than the threshold, charges stop). Shows what the target buys now against the threshold and what it bought at signing. Claimable by the company's public ledger signatories; one open per company. Closed resolved by liquidity-check once the target buys enough again. change (card-action change, #25 phase 6) starts Change automatic payments amounts as the workflow's child; the card closes when the child ends.",
  "inputs": {},
  "outcomes": {
    "resolved": {
      "serverOnly": true
    },
    "change": {
      "serverOnly": true
    },
    "stopped": {
      "serverOnly": true
    }
  }
}
